import { PillTone } from "@b2bportal/core-ui";
import {
  type ReservationState,
  ReservationStateEnum,
} from "@b2bportal/ground-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { ReservationStatusPill } from "@/components";

export const CarReservationStatusPill = ({
  state,
  isPastTrip = false,
  className,
}: {
  state: ReservationState;
  isPastTrip?: boolean;
  className?: string;
}) => {
  const { t } = useI18nContext();

  const reservationStateContentMap = {
    [ReservationStateEnum.Failure]: {
      title: t("problem"),
      pillTone: PillTone.error,
    },
    [ReservationStateEnum.Cancelled]: {
      title: t("cancelled"),
      pillTone: PillTone.error,
    },
    [ReservationStateEnum.Confirmed]: {
      title: t("confirmed"),
      pillTone: PillTone.success,
    },
    [ReservationStateEnum.Pending]: {
      title: t("pending"),
      pillTone: PillTone.neutral,
    },
    Completed: {
      title: t("apac.trips.completed"),
      pillTone: PillTone.neutral,
    },
  };

  const isReservationComplete =
    isPastTrip &&
    state.ReservationState !== ReservationStateEnum.Cancelled &&
    state.ReservationState !== ReservationStateEnum.Failure;

  const { title, pillTone } = isReservationComplete
    ? reservationStateContentMap.Completed
    : reservationStateContentMap[state.ReservationState];

  return (
    <ReservationStatusPill
      tone={pillTone}
      className={clsx(
        className,
        state.ReservationState,
        isPastTrip ? "passed" : undefined
      )}
    >
      {title}
    </ReservationStatusPill>
  );
};
